import { Component, OnInit } from '@angular/core';
import { MainListViewComponent } from '../main-listview/main-listview.component';
import { EarhivUiComponents } from '@app/shared/models/earhiv-ui-components';

@Component({
  selector: 'app-registar-arhiva',
  templateUrl: './registar-arhiva.component.html',
  styles: [':host { flex-grow: 1 }']
})
export class RegistarArhivaComponent
  extends MainListViewComponent
  implements OnInit
{
  override INIT_COMP_ID = EarhivUiComponents.COMMON_TABLE_LIST_GRID_VIEW;

  override ngOnInit() {
    this.changeView('registar_arhiva_i_posjednika');
  }

  tablica = [
    'en~agent~naziv',
    'en~arhiv_posjednik~sjediste_labela',
    'en~arhiv_posjednik~tip_posjednika',
    'en~arhiv_posjednik~nadlezni_arhiv',
    'en~agent~osnivac_labela',
    'en~arhiv_posjednik~status'
  ];

  lista = [
    'en~arhiv_posjednik~oznaka',
    'en~agent~naziv',
    'en~arhiv_posjednik~content_id',
    'en~arhiv_posjednik~status',
    'en~arhiv_posjednik~tip_posjednika'
  ];

  grid = [
    'en~arhiv_posjednik~oznaka',
    'en~agent~naziv',
    'en~arhiv_posjednik~content_id',
    'en~arhiv_posjednik~status',
    'en~arhiv_posjednik~tip_posjednika'
  ];
}
